import React from 'react'
import styled from 'styled-components'
import IxAutoAwesomeIcon from '../../../assets/icon-ixautoawesome'
import IconContainerWrapper from '../../components/IconContainerWrapper'

interface SPUDRecordStatusContainerProps {
  header: boolean | undefined
  inline: boolean | undefined
  table: boolean | undefined
}

const SPUDRecordStatusContainer = styled.div<SPUDRecordStatusContainerProps>`
  padding: ${props => {
    if (props.inline) return '0px 0px 0px 1em'
    if (props.table) return '0'
    return '20px 15px'
  }};
  height: ${props => props.inline ? '2em' : '100%'};
  display: flex;
  flex-direction: row;
  justify-content: ${props => props.table ? 'flex-start' : 'center'};
  align-items: center;
  background-color: ${props => props.header ? '#E3EDFA' : 'auto'};

  @media (max-width: ${({ theme }) => theme.breakpoints.xl}) {
    font-size: 0.8rem;
  }
`

interface SPUDRecordStatusIndicatorProps {
  status: string | undefined
}

const SPUDRecordStatusIndicator = styled.div<SPUDRecordStatusIndicatorProps>`
  border-radius: 50%;
  width: 1.5em;
  height: 1.5em;
  margin-right: 10px;
  min-width: 1.5em;
  min-height: 1.5em;
  background-color: ${props => {
    if (props.status === 'draft') return '#478fe5'
    if (props.status === 'published') return '#25af06'
    if (props.status === 'deleted') return '#d90e0e'
    return 'orange'
  }};

  @media (max-width: 1440px) {
    width: 0.7em;
    height: 0.7em;
    margin-right: 1px;
  }
`

const SPUdRecordStatusBrackets = styled.span`
  font-size: 2em;
`

type Props = {
  status: string,
  issId: number | null,
  active?: boolean | undefined,
  header?: boolean
  inline?: boolean
  table?: boolean
}

function SPUDRecordStatus ({ status, active, header, inline, table, issId }: Props): React.ReactElement {
  const currentStatus = active ? status || 'draft' : 'deleted'

  const formatStatus = (): React.ReactElement => {
    return table
      ? (
        <h4 style={{ margin: '3px 0px', display: 'flex', alignItems: 'center' }}>
          {currentStatus.toUpperCase()}
          {!issId
            ? (
              <IconContainerWrapper icon= {<IxAutoAwesomeIcon width="1.3em" height="1.3em" />} text={'NEW'}/>
            )
            : ''}
        </h4>
      )
      : (
        <h4 style={{ display: 'flex', alignItems: 'center' }}>
          {status.toUpperCase()}
          {!issId
            ? (
              <IconContainerWrapper icon= {<IxAutoAwesomeIcon width="1.3em" height="1.3em" />} text={'NEW'}/>
            )
            : ''}
        </h4>
      )
  }

  const renderInlineHeaderStatus = () => (
    <>
      <SPUdRecordStatusBrackets>( </SPUdRecordStatusBrackets>
      <SPUDRecordStatusIndicator status={currentStatus} /> {formatStatus()}
      <SPUdRecordStatusBrackets>) </SPUdRecordStatusBrackets>
    </>
  )

  return (
    <SPUDRecordStatusContainer header={header} inline={inline} table={table}>
      {inline
        ? renderInlineHeaderStatus()
        : (
          <>
            <SPUDRecordStatusIndicator status={currentStatus} /> {formatStatus()}
          </>
        )}
    </SPUDRecordStatusContainer>
  )
}

export default SPUDRecordStatus
